export default __webpack_public_path__ + "static/media/invite_code_new_user.eecda843.png";